import "./styles/CommonLoader.css";
import Images from "../constant/images";

const CommonLoader = ({ visible = false }) => {
  if (!visible) return null;

  return (
    <div className="loader-backdrop">
      <div className="loader-container">
        <img src={Images.logo} alt="Loading..." className="loader-logo" />
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
};

export default CommonLoader;
